import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-12 md:mb-16">
          分类浏览
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/category/${category.slug}`}
              className="group relative rounded-2xl overflow-hidden aspect-[4/3] cursor-pointer"
            >
              <img
                src={category.image}
                alt={`${category.name} - 韩国漫画分类`}
                title={`${category.name} 韩漫分类`}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
                <h3 className="text-xl md:text-2xl font-heading font-bold text-white mb-1">
                  {category.name}
                </h3>
                <p className="text-sm text-white/70">{category.description}</p>
                <span className="mt-3 inline-block px-4 py-1 rounded-full bg-white/15 backdrop-blur-sm text-white text-xs font-label">
                  {category.count.toLocaleString()} 部作品
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}